export default "__VITE_ASSET___b8bwplN__"